var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMana0)",
    d: "M9.858 9.428v5.143h4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.716 14.571h4.142V9.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D55",
    d: "M7.886 17.571A7.13 7.13 0 0 0 12 18.857a7.13 7.13 0 0 0 4.115-1.286z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC5B",
    d: "M5.716 14.571q.322.691.799 1.286h7.83V14.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMana1)",
    d: "M14.586 12.857v3.857h3.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.445 16.714h3.14v-3.857z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC95B",
    d: "M14.586 11.314a1.714 1.714 0 1 0 0-3.428a1.714 1.714 0 0 0 0 3.428M9.858 8.571a.857.857 0 1 0 0-1.714a.857.857 0 0 0 0 1.714"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMana0",
    x1: 11.913,
    x2: 11.913,
    y1: 6.857,
    y2: 18.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMana1",
    x1: 11.719,
    x2: 11.719,
    y1: 6.857,
    y2: 18.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana);
export default __webpack_public_path__ + "static/media/mana.2ad3ae45a420ddd877c6a1b74abce3e0.svg";
export { ForwardRef as ReactComponent };